import type { BuiltInIssueStatus, IssueStatus } from "../types";

/**
 * The three built-ins' presentation. Keyed by BuiltInIssueStatus, not
 * IssueStatus: IssueStatus is now open, so a Record over it would type-check
 * a lookup of a custom key that is not in here. Custom statuses carry their
 * own colours; resolve BOTH through statuses/statusCatalogue.
 */
export const ISSUE_STATUS_CONFIG: Record<
  BuiltInIssueStatus,
  { label_en: string; label_et: string; textColor: string; bgColor: string; dotColor: string }
> = {
  in_progress: {
    label_en: "In Progress",
    label_et: "Töös",
    textColor: "#1565c0",
    bgColor: "#e3f2fd",
    dotColor: "#1976d2",
  },
  resolved: {
    label_en: "Resolved",
    label_et: "Lahendatud",
    textColor: "#2e7d32",
    bgColor: "#e8f5e9",
    dotColor: "#388e3c",
  },
  closed: {
    label_en: "Closed",
    label_et: "Suletud",
    textColor: "#616161",
    bgColor: "#f5f5f5",
    dotColor: "#9e9e9e",
  },
};

/**
 * @deprecated The built-ins alone. A surface that offers statuses to a user
 * must use `visibleStatuses(catalogue, projectId)` instead, or custom statuses
 * are silently missing from it.
 */
export const ISSUE_STATUSES: IssueStatus[] = ["in_progress", "resolved", "closed"];

/**
 * Rows per request while the issue list reads a building's scope.
 *
 * Not a cap on what the list shows — IssuesStore keeps paging until the scope
 * is exhausted. Bigger pages mean fewer round trips; each page also drives a
 * handful of hydration reads whose fan-out grows with it, so this stays well
 * inside PostgREST's 1000-row ceiling.
 */
export const PM_PAGE_SIZE_ISSUES = 200;

/**
 * Hard ceiling on how many issues one scope will load into memory.
 *
 * A safety net, not a page size: past this the browser is holding more rows
 * than a person can read and the table more nodes than it can lay out
 * smoothly. Reaching it sets `IssuesStore.truncated`, and the list says so and
 * points at search and filters — a visible ceiling beats a silent one.
 */
export const PM_ISSUE_LOAD_CEILING = 5000;
